import { getCookie } from '@alexis/helpers/cookie';
import { useSearchParams } from 'react-router-dom';

export const useFbpFbc = () => {
  const [searchParams] = useSearchParams();
  const fbc = searchParams.get('fbclid');
  const fbp = getCookie('_fbp');

  return {
    fbc,
    fbp,
  };
};
